import React from 'react';
import { Table, Button, Space, Popconfirm } from 'antd';
import { DeleteOutlined, SwapOutlined } from '@ant-design/icons';

const BatchTable = ({ 
  batches, 
  loading, 
  pagination, 
  onTableChange, 
  onViewOrders,
  onAssignAirwayBill,
  onDeleteBatch 
}) => {
  const columns = [
    {
      title: '批次号',
      dataIndex: 'batch_number',
      key: 'batch_number',
    },
    {
      title: '客户',
      dataIndex: 'customer_name',
      key: 'customer_name',
    },
    {
      title: '订单数量',
      dataIndex: 'order_count',
      key: 'order_count',
    },
    {
      title: '空运单',
      dataIndex: 'airway_bill_number',
      key: 'airway_bill_number',
      render: (text) => text || '未分配',
    },
    {
      title: '创建时间',
      dataIndex: 'created_at',
      key: 'created_at',
      sorter: true,
      defaultSortOrder: 'descend',
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space size="middle" onClick={e => e.stopPropagation()}>
          <Button 
            type="link"
            icon={<SwapOutlined />}
            onClick={(e) => onAssignAirwayBill(e, record.id)}
          >
            分配空运单
          </Button>
          <Popconfirm
            title="确定要删除这个批次吗？此批次的订单不会被删除"
            onConfirm={(e) => onDeleteBatch(e, record.id)}
            okText="确定"
            cancelText="取消"
          >
            <Button type="link" danger icon={<DeleteOutlined />}>
              删除批次
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={batches}
      rowKey="id"
      loading={loading}
      pagination={pagination}
      onChange={onTableChange}
      onRow={(record) => ({
        onClick: () => onViewOrders(record),
        style: { cursor: 'pointer' }
      })}
    />
  );
};

export default BatchTable;
